exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Questions{padding:20px;background:#fff;width:100%;margin:0}.Questions .block-message{padding:20px;border:1px solid #d1d1d1;margin-bottom:10px;background:#f2f6f8}.Questions .question-buttons .block{border:1px solid #d1d1d1;width:40px;height:40px;display:flex;align-items:center;justify-content:center}.Questions .question-body .question-text-html{padding:10px;border:1px solid #d1d1d1;margin-bottom:10px}.Questions .question-body .question-text-html ul{padding:0 20px}.Questions .question-body .answers-block .answer-content{width:100%;max-width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QuestionImport/components/style.scss
// module id = 5164
// module chunks = 0